import React, { Component } from 'react';
import contact from '../../assets/images/icons/contact-icn.svg';
import url from '../../assets/images/icons/url-icn.svg';
import map from '../../assets/images/icons/map-icn.svg';
import { Textfit } from 'react-textfit';
import center from '../../assets/images/loader/center_placeholder.svg';

class CenterCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            image: null,
        };
    }

    componentDidMount() {
        if (this.props.image === null) {
            this.setState({
                image: center,
            });
        } else {
            this.setState({
                image: this.props.image,
            });
        }
    }

    render() {
        return (
            <div className='centers_card'>
                <div
                    className='card_image'
                    style={{
                        backgroundImage: `url(${this.state.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                    }}
                ></div>
                <div className='card_body'>
                    <div className='center_name'>
                        <Textfit mode='multi' min={18} max={22}>
                            {this.props.name}
                        </Textfit>
                    </div>
                    <div className='center_location'>
                        <Textfit mode='single' min={14} max={18}>
                            {this.props.city}, {this.props.district}
                        </Textfit>
                    </div>
                </div>
                <div className='card_buttons'>
                    <a href={`tel:${this.props.phone}`} target='_blank'>
                        <div className='icn_border'>
                            <img src={contact} alt='contact' />
                        </div>
                    </a>
                    <a href={`${this.props.website}`} target='_blank'>
                        <div className='icn_border'>
                            <img src={url} alt='url' />
                        </div>
                    </a>
                    <a href={`${this.props.location}`} target='_blank'>
                        <div className='icn_border'>
                            <img src={map} alt='map' />
                        </div>
                    </a>
                </div>
            </div>
        );
    }
}

export default CenterCard;
